<template>
  <DModal @close="$emit('close')" :isBgOverlay="true"
          :show-close="false">
    <div class="do-modal" slot="insertComponent">
      <div class="do-modal__header">
        <h2>Deaktiver puljer</h2>
        <div class="icon__bg-circle ww-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="do-modal__body">
        <div class="d-explainer-box text-explainer text-explainer__error">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-help">
            <path class="primary" d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/>
            <path class="secondary"
                  d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"/>
          </svg>
          Deaktiver puljer for Undervisning, Øvrige opgaver m.m., så systemet i stedet beregner en samlet pulje baseret på det samlede antal timer allokeret på brikker.
        </div>
        <div class="d-label-and-toggle" @click.stop="setDeactivatePoolsActive">
          <label class="d-label color-dark">Deaktiver puljer</label>
          <div class="do-switch" :class="{'do-switch--active': isDeactivatePoolsActive}"></div>
        </div>
        <template v-if="canConfigureAssignedPoolNormWhenPoolsDeactivated && isDeactivatePoolsActive">
          <div class="d-explainer-box text-explainer marg-1-top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-help">
              <path class="primary" d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/>
              <path class="secondary"
                    d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"/>
            </svg>
            Brug puljen fra {{ localPoolTitle }} i stedet for summen af {{ localPoolTitle }}-brikker i sammentællingen.
          </div>
          <div class="d-label-and-toggle" @click.stop="setAssignedPoolFromNormActive">
            <label class="d-label color-dark">{{ localPoolTitle }} fra årsnorm</label>
            <div class="do-switch" :class="{'do-switch--active': isAssignedPoolFromNormActive}"></div>
          </div>
        </template>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import eventbus from '../../eventbus'
import {mapGetters} from 'vuex'
import {ASSIGNED_POOL_FROM_NORM_SETTING_KEY} from '../../utils/assignedPoolWhenPoolsDeactivated'

export default {
  components: {DModal},
  props: {
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDeactivatePoolsActive: false,
      isAssignedPoolFromNormActive: false,
      isSaving: false,
      deactivatePoolsSettingKey: 'deactivatePools'
    }
  },
  computed: {
    ...mapGetters([
      'canConfigureAssignedPoolNormWhenPoolsDeactivated',
      'localPoolTitle'
    ])
  },
  watch: {
    isPoolsDeactivated (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.$emit('reReadNumbers')
      eventbus.toast = {text: 'Gemt for skolen', 'success': true}
    }
  },
  methods: {
    setDeactivatePoolsActive () {
      this.isDeactivatePoolsActive = !this.isDeactivatePoolsActive
      if (!this.isDeactivatePoolsActive) {
        this.isAssignedPoolFromNormActive = false
      }
      setTimeout(_ => {
        this.onSaveDeactivatePools()
      }, 250)
    },
    setAssignedPoolFromNormActive () {
      this.isAssignedPoolFromNormActive = !this.isAssignedPoolFromNormActive
      setTimeout(_ => {
        this.onSaveAssignedPoolFromNorm()
      }, 250)
    },
    onSaveDeactivatePools () {
      this.isSaving = true
      if (!this.isDeactivatePoolsActive) {
        this.$store.dispatch('updateSchoolSettings', {
          [this.deactivatePoolsSettingKey]: null,
          [ASSIGNED_POOL_FROM_NORM_SETTING_KEY]: null
        })
      } else {
        this.$store.dispatch('updateSchoolSettings', {[this.deactivatePoolsSettingKey]: true})
      }
    },
    onSaveAssignedPoolFromNorm () {
      if (!this.isDeactivatePoolsActive) {
        return
      }
      this.isSaving = true
      if (!this.isAssignedPoolFromNormActive) {
        this.$store.dispatch('deleteSchoolSetting', ASSIGNED_POOL_FROM_NORM_SETTING_KEY)
      } else {
        this.$store.dispatch('updateSchoolSettings', {[ASSIGNED_POOL_FROM_NORM_SETTING_KEY]: true})
      }
    }
  },
  mounted () {
    if (this.isPoolsDeactivated) {
      this.isDeactivatePoolsActive = true
    }
    if (this.$store.getters.isAssignedPoolFromNormWhenPoolsDeactivated) {
      this.isAssignedPoolFromNormActive = true
    }
  }
}
</script>

<style scoped>

.do-modal__body {
  background: #edf0f5;
  max-height: calc(100vh - 105px);
  overflow-y: auto;
  overscroll-behavior: contain;
  min-width: 500px;
  padding: 1rem;
}

.d-label-and-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  padding: 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 2rem;
}

.d-label-and-toggle label {
  cursor: pointer;
}

.d-label-and-toggle:hover {
  background: aliceblue;
}

.prep-factor-input {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.prep-factor-input > input {
  width: 80px;
  text-align: center;
  background: #fff;
}

.color-dark {
  color: #222 !important;
}

.d-explainer-box {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 480px;
}

.d-explainer-box .tw-icon {
  min-width: 24px;
}

.marg-1-top {
  margin-top: 1rem;
}

</style>



// WEBPACK FOOTER //
// AssignHoursDeactivatePoolsModal.vue?1843279a